import { Button, Dialog, Fill, NAME_SOUND_ACTIVE, useGameSounds, useTranslate } from "@educaplay/core";
import { Exit } from "@educaplay/core/Icons/Exit";
import { Skip } from "@educaplay/core/Icons/Skip";
import { AnimatePresence, motion } from "framer-motion";
import classes from './SkipButton.module.scss';
import { useState } from "react";

export const SkipButton = (props) => {
    const { show, onSkip, isLastQuestion } = props;
    const [openDialog, setOpenDialog] = useState(false);
    const t = useTranslate();
    const gameSounds = useGameSounds();

    const passQuestionHandler = () => {
        setOpenDialog(true);
    }

    const closeDialogHandler = () => {
        setOpenDialog(false);
    }

    const onClickHandler = () => {  
        onSkip();
        setOpenDialog(false);
    }

    const msg = isLastQuestion ? t("common.game.abandon") : t('specific.modalmsgpass');
    const icon = isLastQuestion ? <Exit className={classes.exiticon} /> : <Skip className={classes.skipicon} />;

    return (
        <Fill name={"core-footer-buttons-right"}>
            <Dialog open={openDialog} onClose={closeDialogHandler}>
                <div className={classes.modal} onClick={(e) => { e.stopPropagation() }}>
                    <div className={classes.modalHeader}>
                        <p>{msg}</p>
                    </div>
                    <div className={classes.modalFooter}>
                        <Button className={classes.btnCancel} onClick={closeDialogHandler}>{t("common.settings.cancel")}</Button>
                        <Button className={classes.btnAccept} onClick={onClickHandler}>{t("common.settings.accept")}</Button>
                    </div>
                </div>
            </Dialog>

            <AnimatePresence>
                {show && (
                    <motion.div
                        className={classes.buttoncontainer}
                        initial={{ opacity: 0, x: "100%" }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: .3, type: "spring", delay: .2 }}
                    >
                        <button className={classes.buttonpassquestion} onClick={passQuestionHandler} onMouseEnter={()=> gameSounds.play(NAME_SOUND_ACTIVE)}>
                            {icon}
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </Fill>
    )
}